import fetch from 'isomorphic-fetch';
import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();
const { GF_DOTCOM_YOTPO_APP_KEY } = publicRuntimeConfig;
const yotpoWidgetApiBaseUrl = `https://api.yotpo.com/v1/widget/${GF_DOTCOM_YOTPO_APP_KEY}`;

/**
 * @param {string} productId
 */
// eslint-disable-next-line import/prefer-default-export
export const fetchReviewsByProductId = async (productId) => {
  try {
    const response = await fetch(`${yotpoWidgetApiBaseUrl}/products/${productId}/reviews.json`);
    if (response.status === 200) {
      const json = await response.json();
      return json.response;
    }
    return null;
  } catch (e) {
    return null;
  }
};
